import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export async function getShortUrl(url: string): Promise<string> {
    const { apiGetShortUrl } = apiConfig.getStaticUrls();

    const { data } = await  getFetch(apiGetShortUrl, { url });

    return data;
}
